export default __webpack_public_path__ + "static/media/Sri_shakthi_engineering.8d89b131.png";